/**
 * FilterChips — quick-filter pills above the results list.
 * Suggested / Cheapest / Fastest / Nonstop / 1 Stop / 2+ Stops.
 *
 * @param {Object} props
 * @param {string} props.active
 * @param {(key:string) => void} props.onChange
 */
import React from "react";
import "./filter-chips.css";

export const CHIPS = [
  { key: "suggested", label: "Suggested" },
  { key: "cheapest", label: "Cheapest" },
  { key: "fastest", label: "Fastest" },
  { key: "nonstop", label: "Nonstop" },
  { key: "1stop", label: "1 Stop" },
  { key: "2stops", label: "2+ Stops" },
];

export default function FilterChips({ active, onChange }) {
  return (
    <div className="fchips" role="tablist" aria-label="Quick filters">
      {CHIPS.map((chip) => (
        <button
          type="button"
          key={chip.key}
          role="tab"
          aria-selected={active === chip.key}
          className={`fchip ${active === chip.key ? "fchip--active" : ""}`}
          onClick={() => onChange(chip.key)}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
